import { Directive, Input, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { AuthService } from '../services/authservice';

@Directive({
    selector: '[accessRights]'
})
export class AccessRightDirective implements OnInit {

    @Input('accessRights') accessRights = [];
    sub;
    hasView = false;
    constructor(private auth: AuthService, private container: ViewContainerRef, private template: TemplateRef<any>) {

    }
    /*
    ngOnInit() {
        this.sub = this.auth.User.subscribe((user) => {
            if (!user) {
                if (this.hasView) {
                    this.container.clear();
                    this.hasView = false;
                }
                return;
            }
          
            if (this.accessRights.some(a => this.auth.GetAccessRight(a))) {
                if (!this.hasView) {
                    this.container.createEmbeddedView(this.template);
                    this.hasView = true;
                }
            } else if (this.hasView) {
                this.container.clear();
                this.hasView = false;
            }
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    */

    ngOnInit() {

        if (!this.auth.User) {
            this.removeView();
        }


        if (this.accessRights.some(r => this.auth.HasAccessRight(r))) {
            this.createView();
        } else {
            this.removeView();
        }
    }

    removeView() {
        if (this.hasView) {
            this.container.clear();
            this.hasView = false;
        }
    }

    createView() {
        if (!this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
        }
    }



}
